<template>
  <div class="map-service-box">
    <div class="filter-box">
      <div class="common-input-box">
        <el-input
          class="input-primary"
          size="small"
          placeholder="请输入服务名称"
          clearable
          @clear="search"
          v-model="keywords"
          @keyup.enter.native="search">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search icon"
            @click="search" />
        </el-input>
      </div>
      <div class="common-button-box">
        <el-button
          class="primary-btn"
          v-if="isChecked('Project.Single.Template.Wmts.Create')"
          size="small"
          type="primary"
          @click="createMapService">
          新建服务
        </el-button>
      </div>
    </div>
    <div
      ref="serviceListDom"
      class="map-service-list-box"
      v-infinite-scroll="handleScroll"
      :infinite-scroll-distance="20">
      <template v-if="serviceList && serviceList.length">
        <div
          v-for="(item, index) in serviceList"
          :key="index"
          :class="`list-item-box ${isActive(item) ? 'active' : ''}`"
          @click="mapServiceClick(item)">
          <div
            v-if="isActive(item)"
            class="operation-btn-box">
            <div class="icon-box">
              <icon-svg icon-class="icon-duihao" />
            </div>
            <div class="common-button-box">
              <el-button
                v-if="isBtnVisible(item, 'Update')"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                circle
                title="修改"
                @click="editMapService(item)" />
            </div>
            <div class="common-button-box">
              <el-button
                v-if="isBtnVisible(item, 'Delete')"
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
                title="删除"
                @click="deleteMapService(item)" />
            </div>
          </div>
          <div class="thumbnail-box">
            <img :src="require('@/assets/img/no-map.png')" />
          </div>
          <div class="map-service-info-box">
            <div class="item-box">
              <div class="label-box">服务名称：</div>
              <div
                class="value-box text-overflow"
                :title="item.serviceName">
                {{ item.serviceName }}
              </div>
            </div>
            <div class="item-box">
              <div class="label-box">坐标系：</div>
              <div
                class="value-box text-overflow"
                :title="item.worCRS">
                {{ item.worCRS }}
              </div>
            </div>
            <div class="item-box">
              <div class="label-box">选自层：</div>
              <div
                class="value-box text-overflow"
                title="--">
                --
              </div>
            </div>
          </div>
        </div>
      </template>

      <div
        class="empty-page"
        v-else>
        <bj-empty
          :image="require('@/assets/img/no-data.png')"
          class="empty-page">
          <template slot="description">
            <span class="empty-text">抱歉，没有找到相关内容</span>
          </template>
        </bj-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from '@/utils/store'
import { formatTime } from '@/utils/generalMethods'

import {
  getWmtsTemplateService,
  deleteWmtsServeService,
  deleteWmtsPreServeService
} from '@/service/interface'

export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      keywords: '',
      serviceList: []
    }
  },
  props: {
    currMapServiceInfo: Object,
    updateCurrMode: Function,
    updateCurrMapServiceInfo: Function
  },
  mounted() {
    this.$nextTick(() => {
      this.initMapServiceList()
    })
  },
  methods: {
    initMapServiceList() {
      this.queryMapServiceList().then(serviceList => {
        this.serviceList = serviceList
        let mapServiceInfo = serviceList[0]
        this.mapServiceClick(mapServiceInfo)
      })
    },
    search() {
      this.queryMapServiceList().then(serviceList => {
        this.serviceList = serviceList
      })
    },
    updateMapServiceList(serviceId) {
      return new Promise(resolve => {
        this.queryMapServiceList().then(serviceList => {
          this.serviceList = serviceList

          let find = this.serviceList.find(
            el => el.wmtsTemplateId === serviceId
          )
          if (find) {
            this.mapServiceClick(find, true)
          }
          resolve()
        })
      })
    },
    createMapService() {
      this.updateCurrMode('createService')
    },
    editMapService() {
      this.updateCurrMode('editService')
    },
    deleteMapService(mapServiceInfo) {
      this.$confirm('确定要删除该服务吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let domRef = this.$refs.serviceListDom
          let serviceId = mapServiceInfo.wmtsTemplateId
          if (mapServiceInfo.isIntrinsic) {
            deleteWmtsPreServeService(serviceId).then(response => {
              if (response.isSuccess) {
                this.currentPage = 1
                this.keywords = ''
                this.queryMapServiceList().then(serviceList => {
                  this.$message.success('删除成功！！！')

                  this.serviceList = serviceList
                  let mapServiceInfo = serviceList[0]
                  this.mapServiceClick(mapServiceInfo)

                  domRef.scrollTo({ top: 0, behavior: 'smooth' })
                })
              } else {
                this.$message.error(response.errMsg)
              }
            })
          } else {
            deleteWmtsServeService(serviceId).then(response => {
              if (response.isSuccess) {
                this.currentPage = 1
                this.keywords = ''
                this.queryMapServiceList().then(serviceList => {
                  this.$message.success('删除成功！！！')

                  this.serviceList = serviceList
                  let mapServiceInfo = serviceList[0]
                  this.mapServiceClick(mapServiceInfo)

                  domRef.scrollTo({ top: 0, behavior: 'smooth' })
                })
              } else {
                this.$message.error(response.errMsg)
              }
            })
          }
        })
        .catch(() => {})
    },
    mapServiceClick(mapServiceInfo, isForceUpdate) {
      this.updateCurrMapServiceInfo(mapServiceInfo, isForceUpdate)
    },
    isActive(mapServiceInfo) {
      // prettier-ignore
      return this.currMapServiceInfo.wmtsTemplateId === mapServiceInfo.wmtsTemplateId;
    },
    handleScroll() {
      if (this.allDataLoaded) return
      if (this.serviceList.length < this.pageSize) return
      this.currentPage++
      this.queryMapServiceList().then(serviceList => {
        if (serviceList.length) {
          this.serviceList = [...this.serviceList, ...serviceList]
        } else {
          this.allDataLoaded = true
        }
      })
    },
    scrollToActiveItem() {
      let domRef = this.$refs.serviceListDom
      let activeDom = domRef.querySelector('.active')
      let activeDomHeight = activeDom.clientHeight
      let offsetDis = activeDom.offsetTop
      let deltaScrollDis = offsetDis - activeDomHeight

      domRef.scrollTo({ top: deltaScrollDis, behavior: 'smooth' })
    },
    queryMapServiceList() {
      return new Promise(resolve => {
        let params = {
          resultCount: this.pageSize,
          skipCount: (this.currentPage - 1) * this.pageSize,
          serviceName: this.keywords
        }
        getWmtsTemplateService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let serviceList = data.items
            resolve(serviceList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    isBtnVisible(mapServiceInfo, btnName) {
      let permissionCode = ''
      let userInfo = Store.userInfo
      let visible = false
      if (mapServiceInfo.creatorId === userInfo.userId) {
        permissionCode = `Project.Single.Template.Wmts.${btnName}`
        visible = this.isChecked(permissionCode)
      } else {
        permissionCode = `Project.Single.Template.Wmts.${btnName}Intrinsic`
        if (mapServiceInfo.isIntrinsic) {
          visible = this.isChecked(permissionCode)
        } else {
          if (this.isChecked(permissionCode)) {
            visible = true
          } else {
            visible = false
          }
        }
      }

      if (visible && btnName === 'Update') {
        if (mapServiceInfo.CapabilityInfo) {
          visible = true
        } else {
          visible = false
        }
      }

      return visible
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    },
    formatTime
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.map-service-box {
  width: 49%;

  .filter-box {
    display: flex;

    .common-input-box {
      width: 270px;
      margin-right: 10px;

      .icon {
        cursor: pointer;
      }
    }
  }

  .map-service-list-box {
    margin-top: 10px;
    padding-right: 5px;
    height: 640px;
    overflow: auto;

    .empty-page {
      height: 100%;
    }

    .list-item-box {
      position: relative;
      display: flex;
      height: 160px;
      margin-bottom: 10px;
      border: 1px solid var(--wmts-mapinfo-border-color);
      cursor: pointer;
      border-radius: 8px;
      overflow: hidden;

      &:hover {
        border-color: var(--base-primary-color);
      }

      .operation-btn-box {
        position: absolute;
        margin: 2px;
        margin-right: 0;
        right: 0px;

        .icon-box {
          width: 24px;
          height: 20px;
          padding-left: 2px;
          color: #ffffff;
          border-radius: 0px 0px 0px 25px;
          background: var(--base-primary-color);
          text-align: center;
          transform: translate(4px, -2px);
          > span {
            margin-left: 2px;
          }

          .svg-icon {
            margin-top: 1px;
          }
        }

        .common-button-box {
          margin: 5px 0px;

          .el-button {
            margin-right: 0px;
            // background-color: var(--error-status-color);
          }
        }
      }

      .thumbnail-box {
        img {
          width: 100%;
          height: 100%;
          vertical-align: bottom;
        }
      }

      .map-service-info-box {
        margin-top: 10px;
        margin-left: 10px;
        line-height: 30px;

        .item-box {
          display: flex;
          line-height: 45px;
          margin-bottom: 0px;
          font-size: 14px;
          font-weight: 400;
          color: var(--wmts-mapinfo-color);
          .label-box {
            width: 100px;
            text-align: right;
          }

          .value-box {
            width: 270px;
            text-align: left;
          }
        }
      }
    }

    .active {
      border-color: var(--base-primary-color);
    }
  }
}
</style>
